import { DISMISS_MODAL, SAVE_SEARCH_REQUEST, SAVE_SEARCH_SUCCESS } from './actions';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

export const RESET_ADD_SEARCH_ALERT = 'la/ui/addSearchAlert/RESET';

// reducer
const DEFAULT_STATE = {
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SAVE_SEARCH_REQUEST:
            return {
                ...state,
                submitted: true,
                success: false,
            };
        case SAVE_SEARCH_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case RESET_ADD_SEARCH_ALERT:
        case DISMISS_MODAL:
            return DEFAULT_STATE;
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.addSearchAlert;

export const addSearchAlertSelector = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const setDefaultAddSearchAlertState = () => async (dispatch: any) => {
    dispatch({
        type: RESET_ADD_SEARCH_ALERT,
    });
};
